exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#limit_reached[data-v-69aca10e]{color:red}.form-control-danger[data-v-69aca10e]{border:1px solid red!important}.form-control-feedback[data-v-69aca10e]{font-size:13px;color:red;padding-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69aca10e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/DynamicContactsForm.vue
// module id = soaW
// module chunks = 67 170